/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessprofile1Inputs */

const en_businessprofile1 = /** @type {(inputs: Businessprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Profile`)
};

const de_businessprofile1 = /** @type {(inputs: Businessprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil`)
};

/**
* | output |
* | --- |
* | "Business Profile" |
*
* @param {Businessprofile1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessprofile1 = /** @type {((inputs?: Businessprofile1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessprofile1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessprofile1(inputs)
	return de_businessprofile1(inputs)
});
export { businessprofile1 as "businessProfile" }